export default __webpack_public_path__ + "static/media/Condiciones_generales_LEP_2026.370aa194.pdf";